import { Translate } from "ra-core";
import type { ReactNode } from "react";

export const FilterCategory = ({
  icon,
  label,
  children,
}: {
  icon: ReactNode;
  label: string;
  children?: ReactNode;
}) => (
  <div className="flex flex-col gap-2 p-3.5 bg-card dark:bg-slate-900/40 border border-border/60 dark:border-slate-800/60 rounded-xl shadow-[0_2px_8px_-1px_rgba(0,0,0,0.02)] transition-all w-full mb-3">
    <h3 className="flex flex-row items-center gap-2 font-bold text-xs uppercase tracking-wider text-foreground dark:text-slate-200">
      <span className="text-primary dark:text-[#00c2a5] flex items-center shrink-0 [&_svg]:w-4 [&_svg]:h-4">{icon}</span>
      <Translate i18nKey={label} />
    </h3>
    <div className="flex md:flex-col flex-wrap items-start w-full gap-0.5 pl-1 mt-1">
      {children}
    </div>
  </div>
);
